import React from 'react';

import { ProgressTracker as AtlaskitProgressTracker } from '@qality/common-components/src/atoms/atlaskit/ProgressTracker';

/**
Step
status: 'disabled' | 'visited' | 'current' | 'unvisited'
 */

export const ProgressTracker = ({
  steps = [],
  currentStepNumber = 0,
}: {
  steps: Array;
  currentStepNumber: number;
}) => {
  const getSteps = () =>
    steps.map((step, idx) => {
      let status = 'unvisited';

      if (idx === currentStepNumber) {
        status = 'current';
      } else if (idx < currentStepNumber) {
        status = 'visited';
      }

      return {
        id: step.label,
        label: step.label,
        status,
        percentageComplete: status === 'visited' ? 100 : 0,
        href: step.href,
        disabled: step.disabled,
      };
    });

  return <AtlaskitProgressTracker items={getSteps()} />;
};
